export type HyperlinkItemContent = {
  readonly key: string;
  readonly url: string;
  readonly href: string | undefined;
  readonly label: string;
  readonly resolve: boolean;
};

/**
 * Immutable semantic presentation for one Hyperlink field value.
 */
export type HyperlinkReadContent = {
  readonly kind: 'hyperlink';
  readonly links: readonly HyperlinkItemContent[];
};

export const EMPTY_HYPERLINK_CONTENT: HyperlinkReadContent = Object.freeze({
  kind: 'hyperlink',
  links: Object.freeze([])
});
